import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  main: {
    width: '58.56vw',
    height: '65.34vh',
    margin: 'auto',
    outline: 'none',
    borderRadius: '2px',
    marginTop: '17.8vh',
    background: themeColor.modalBackground,
  },
  contentContainer: {
    padding: '3.125vh 1.75vw 0',
    maxHeight: '45vh',
    overflowY: 'auto',
    flexGrow: 1,
  },
  bottomContainer: {
    padding: '0 1.75vw 3.125vh',
  },
  notificationDetailsContainer: {
    width: 'auto',
    marginLeft: '4px',
    flexGrow: 1,
    maxWidth: '46vw',
  },
  notificationContent: {
    flexGrow: 1,
  },
  notificationTitle: {
    letterSpacing: '0.63px',
    color: themeColor.defaultTextColor,
    fontSize: rem(1.5),
    fontWeight: 500,
  },
  notificationIndex: {
    display: 'table-cell',
    verticalAlign: 'middle',
    letterSpacing: '0.56px',
    color: themeColor.blackish,
    fontSize: rem(1.2),
    fontWeight: 500,
    lineHeight: '1.8',
  },
  notificationMessage: {
    letterSpacing: '0.56px',
    color: themeColor.blackish,
    fontSize: rem(1.2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  paginationContainer: {
    flexGrow: 1,
    width: 'auto',
  },
  divider: {
    paddingTop: '2.86vh',
    paddingBottom: '2.21vh',
  },
}));
